import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/Input";
import { useCrudUser } from "@/hooks/parametres/useCrudUser";
import { Roles, User } from "@/redux/services/user/user.type";
import { ModalProps } from "@/lib/type";
import { Select } from "@/components/Select";
import { useAppSelector } from "@/redux/features/hooks";
import { useGetRestaurantsQuery } from "@/redux/services/restaurant/restaurant.api";

const allRoles = [
  { label: "Serveur", value: Roles.waiter },
  { label: "Cuisine", value: Roles.kitchen },
  { label: "Caissier", value: Roles.cashier },
  { label: "Staff", value: Roles.staff },
];

const AddUserModal: React.FC<ModalProps<User>> = ({
  isOpen,
  onClose,
  item,
}) => {
  const { currentUser, currentRestaurant } = useAppSelector((s) => s.user);
  const isOwner = currentUser?.roles?.includes(Roles.owner);

  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string>(
    currentRestaurant?.id ?? ""
  );

  const { register, onSubmit, errors, isLoading, onSelectRoles, selectRole } =
    useCrudUser(onClose, item, isOwner ? selectedRestaurantId : undefined);

  const { data: restaurants } = useGetRestaurantsQuery(undefined, {
    skip: !isOwner,
  });

  const roles = allRoles;

  const restaurantOptions =
    restaurants?.map((r) => ({ label: r.name, value: r.id })) ?? [];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <DialogHeader className="mb-8">
            <DialogTitle>
              {item ? "Modifier l'" : "Ajouter un"} utilisateur
            </DialogTitle>

            {isOwner && !item && (
              <div>
                <Select
                  label="Restaurant"
                  id="restaurant"
                  placeholder="Choisir un restaurant"
                  required
                  options={restaurantOptions}
                  value={selectedRestaurantId}
                  onChange={(e) => setSelectedRestaurantId(e.currentTarget.value)}
                />
              </div>
            )}

            <div>
              <Input
                label="Nom complet"
                type="text"
                id="name"
                placeholder="Nom complet"
                required
                {...register("fullName")}
                error={errors?.fullName}
                defaultValue={item?.fullName}
              />
            </div>
            <div>
              <Input
                label="Email"
                type="email"
                id="name"
                placeholder="Email"
                {...register("email")}
                error={errors?.email}
                defaultValue={item?.email ?? undefined}
              />
            </div>
            <div>
              <Input
                label="Téléphone"
                type="tel"
                id="phone"
                placeholder="Téléphone"
                required
                {...register("phone")}
                error={errors?.phone}
                defaultValue={item?.phone}
              />
            </div>

            <div>
              <Select
                label="Type d'utilisateur"
                id="type_user"
                //@ts-ignore
                placeholder="Choisir le type"
                required
                options={roles}
                error={errors?.roles?.message}
                onChange={onSelectRoles}
                value={selectRole}
              />
            </div>
          </DialogHeader>

          <DialogFooter>
            <Button
              type="submit"
              isLoading={isLoading}
            >
              {item ? "Modifier" : "Ajouter"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddUserModal;
